import { Globals } from './core/global';
import { GameService } from './core/services/game.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute} from '@angular/router';

import { routerTransition } from './router.animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routerTransition] // register the animation
})
export class AppComponent implements OnInit {

  title = 'GigaPlay | Ooredoo';
  mainLoader$: false;

  constructor(
    private translate: TranslateService,
    public gameservice: GameService,
    private global: Globals,
    protected activatedRouter: ActivatedRoute,
    public router: Router,
    
  ) {
    // this.gameservice.mainLoader.subscribe(val => { this.mainLoader$ = val});
  }

  ngOnInit() {

    // Check HE
    
     

    // First We Check Multi Language

    if (this.global.multiLang) {
      if (localStorage.getItem('lang') == null) {
        this.translate.setDefaultLang(this.global.lang);
        localStorage.setItem('lang', this.global.lang);
      } else {
        this.translate.setDefaultLang(localStorage.getItem('lang'));
     //   this.router.navigate(['/onboarding']);
      }
    }

    


    // if (this.global.multiLang === true) {

    //   if (localStorage.getItem('lang') == null) {

    //     localStorage.setItem('lang', this.global.lang);
    //   }
    // }

  }
}

